<template>
    <div class="sino-card" v-loading.fullscreen.lock="loading">
        <div class="sion-card-title">
            <div class="tab-list">
                <div @click="selectTab(0)" :class="['title' , type == 0?'active': '']">全部<span v-if='type == 0'></span></div>
                <div @click="selectTab(1)" :class="['title' , type == 1?'active': '']">住院慰问<span v-if='type == 1'></span></div>
                <div @click="selectTab(2)" :class="['title' , type == 2?'active': '']">亲属去世<span v-if='type == 2'></span></div>
            </div>
            <div class="btn-block" @click="enterPage" v-if="loginInfo.identity!='4'&&loginInfo.identity!='5'">
                <button class="btn btn-apply">申请</button>
            </div>
        </div>

        <div class="list-block"
            v-infinite-scroll="loadMore"
            infinite-scroll-distance=50
        >
            <div class="card-box" 
                v-for="item in condoleList"
                :key="item.id"
            >
                <div class="row">
                    <p><span class="title">姓名:</span><span class="content">{{item.name}}</span></p>
                    <p><span class="title">申请日期:</span><span class="content">{{item.applyDateStr}}</span></p>
                </div>
                <div class="row">
                    <p><span class="title">科室:</span><span class="content">{{item.dept_name}}</span></p>
                    <p><span class="title">慰问类型:</span><span class="content">{{item.comfortType==1?'住院慰问':'亲属去世'}}</span></p>
                </div>
                <div class="row" v-if="item.comfortType==2">
                    <p class="reason"><span class="title">申请补助金额:</span><span class="content">{{item.money}}</span></p>
                </div>
                <div class="row">
                    <p v-if="item.comfortType==2" class="reason"><span class="title">申请补助事由:</span><span class="content">{{item.reason}}</span></p>
                    <p v-if="item.comfortType==1" class="reason"><span class="title">事由:</span><span class="content">{{item.reason}}</span></p>
                </div>
            </div>

            <p class="nomore" v-if="noMore">没有更多了</p>

            <div v-if="condoleList.length == 0" class="blank">
                <img src="@/images/404-02.png" alt>
            </div>

        </div>
    </div>

</template>

<script>
import { getComfortList } from "@/common/api";
import { toast } from "@/common/api/api.js";
    export default {
        data() {
            return {
                condoleList: [],
                loading: true,
                type:0,
                currentPage:1,
                pageSize:10,
                noMore:false,
                loginInfo:"",
            };
        },
        mounted(){
            this.loginInfo= JSON.parse(window.localStorage.getItem("loginInfo"));
            this.getCondoleList();
        },
        methods:{
            selectTab(type){
                this.type=type;
                // 切换全部初始化
                this.loading=true;
                this.currentPage=1;
                this.condoleList=[];
                this.noMore=false;
                this.getCondoleList();
            },
            getCondoleList(){
                getComfortList({
                    type:this.type,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                }).then(res => {
                    if(res.code ==200){
                        this.loading = false;
                        this.condoleList=[...this.condoleList,...res.data];
                        if(this.condoleList.length>0&&res.data.length==0){
                            this.noMore=true;
                            return;
                        }
                    }else{
                        toast(this, res.message, "error");
                        this.loading = false;
                    }
                })
            },
            enterPage(){
                this.$router.push("/condoleApply");
            },
            loadMore(){
                this.currentPage=this.currentPage+1;
                this.getCondoleList();
            }
        }
    }
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
    .tab-list{
        display:flex;
        flex:6;      
        .title{
            span{
                left:50%;
                transform:translateX(-50%);
            }
        }
    }
    .nomore{
        font-size:12px;
        padding-bottom:10px;
        text-align:center;
        color:#808080;
    }
    .sino-card{
        position:relative;
        .sion-card-title{
            position:absolute;
            top:0;
            width:100%;
        }
        .btn-block{
            text-align: center;
            margin: auto;
            flex:2;
            .btn{
                border:none;
                background:rgba(56,199,196,1);
                border-radius:8px;
                color:#fff;
                padding:8px 15px;
                font-size:14px;
            }
        }
        .list-block{
            overflow:scroll;   
            padding-top:calc(44px + 0.3rem);
            height:calc(100vh - 44px - 0.3rem);        
            .card-box{
                padding:10px 15px;
                border-bottom:1px solid #F4F4F7;
                .row{
                    display:flex;
                    flex-direction:row;
                    justify-content:flex-start;
                    display:flex;
                    p{
                        width:50%;
                        padding:5px 0;
                        .title{
                            font-size:14px;
                            font-family:PingFang SC;
                            font-weight:400;
                            color:rgba(53,53,53,1);
                        }
                        .content{
                            flex:1;
                            padding-left:15px;
                            font-size:14px;
                            font-family:PingFang SC;
                            font-weight:400;
                            color:rgba(136,136,136,1);
                        }
                    }
                    p.reason{
                        width:100%;
                        display:flex;
                        .content{
                            font-size:14px;
                            color:rgba(136,136,136,1);
                            line-height:18px;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
            .nodata{
                text-align center;
                margin-top:20px;
            }
        }
    }


</style>